// extracted by mini-css-extract-plugin
module.exports = {"header":"notifies_header__1NS7T","table":"notifies_table__1_okV"};